define('webshopProductsCategoriesListSelectView',[
  'module',
  'tableFieldView',
  'template!tableFieldCheckboxView'
], function (
  Module,
  FieldView,
  Tpl
) {
  'use strict';

  /**
   * Selection checkbox: toggles the row selection without clearing the other
   * selected rows (a plain click on the row still behaves as usual).
   * The checked / unchecked state is driven by CSS from the row "selected" class.
   */
  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'webshop-products-categories-list-select-view table-field-checkbox-view ' + FieldView.prototype.className,

    events: {
      'mousedown': 'onMouseDown',
      'click': 'stop',
      'dblclick': 'stop'
    },

    onMouseDown: function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (e.which === 3)
        return;

      if (this.rowView.isSelected())
        this.rowView.unSelect();
      else
        this.rowView.select();

      this.tableView.lastSelected = this.rowView;

      if (this.tableView.onSelected)
        this.tableView.onSelected(this.tableView.getSelected());
    },

    stop: function (e) {
      e.stopPropagation();
    }
  });
});

